import sizeof from 'object-sizeof'
import bytesToSize from '@helpers/bytesToSize'
import setObjectPath from "@helpers/setObjectPath.helper";
import metadata from '@store/modules/shared/metadata.modules'
import snapshot from '@store/modules/design/snapshot.modules'
import frameTool from '@store/modules/design/frameTool.modules'
import component from '@store/modules/design/component.modules'
import modals from '@store/modules/design/modals.modules'
import page from '@store/modules/design/page.modules'
import site from '@store/modules/design/site.modules'
import original from '@store/modules/design/original.modules'
import permissionWebsite from '@store/modules/shared/permissionWebsite.modules'
import siteData from '@store/modules/shared/siteData.modules'
import userPreference from '@store/modules/design/userPreference.modules'
import toast from "@helpers/toast.helper"
import axios from "axios";

const state = {
  iframeScale: 1,
  filemanager: undefined,
  mode: undefined,
  allowChildren: process.env.VUE_APP_ALLOW_CHILDREN_POST_MSG,
  iframeWin: undefined,
  modal: '',
  modalPayload: {},
  // BlockLoading
  blockloading: {
    isActive: false
  },
  // Reloading
  reloading: {
    types: {
      buildVersion: {
        reload: false,
        data: {},
      },
      renderVersion: {
        reload: false,
        data: {},
      },
    },
  }
};

const getters = {
  mode: state => {
    return state.mode
  },
  iframeScale: state => {
    return state.iframeScale
  },
  iframeWin: state => {
    return state.iframeWin;
  },
  modal: state => {
    return state.modal;
  },
  modalPayload: state => {
    return state.modalPayload;
  },
  // BlockLoading
  blockloading: state => {
    return state.blockloading;
  },
  // Reloading
  reloading: state => {
    return state.reloading;
  },
};
const actions = {
  syncInit({ dispatch, state }) {
    dispatch('designIframe/init', { iframeScale: state.iframeScale }, { root: true })
  },

  setIframeScale({ commit }, { iframeScale }) {
    commit('SET_IFRAME_SCALE', { iframeScale: iframeScale })
  },
  postToChildren(_, { func, payload, root = false }) {
    state.iframeWin && state.iframeWin.postMessage(
      {
        func,
        root,
        payload,
        timestamp: new Date().getTime()
      },
      state.allowChildren
    );
  },
  registerFilemanager({ commit }, { filemanager }) {
    commit('REGISTER_FILEMANAGER', { filemanager })
  },
  openFilemanager({ state }, options) {
    state.filemanager.init(options)
  },
  callFromChildren({ dispatch }, { txt }) {
    console.log({ txt });
    dispatch('postToChildren', { func: 'callFromParent', payload: { txt: 'pong' } })
    dispatch('postToChildren', { func: 'page/initUrl', payload: { hash: location.hash } })
    // commit("elHover", { elementID, lv });
  },
  childMsg({ dispatch }, event) {
    if (event.origin !== state.allowChildren) return;
    var { func, payload, timestamp, root } = event.data;
    if (func) {
      const delay = new Date().getTime() - timestamp
      if (sizeof(payload) > 100) {
        console.log(`<<< "${func}" payload size ${bytesToSize(sizeof(payload))}, delay ${delay}ms`, payload);
      }
      dispatch(func, payload, { root })
    }
  },
  setMode({ commit, dispatch }, { mode }) {
    commit('SET_MODE', { mode })
    dispatch("postToChildren", {
      func: "setMode",
      payload: { mode },
    })
  },
  callbackChildMounted({ dispatch }) {
    dispatch('setActiveElementfromURL')
    // initPageData
  },
  setModal: ({ commit }, { name, payload }) => {
    commit('SET_MODAL', { name, payload });
  },
  toast(_, { title = '', desc = "", varaint = "info" }) {
    toast.toastCreate({
      parent: this._vm,
      title,
      desc,
      varaint,
    });
  },
  // BlockLoading
  blockloading({ commit }) {
    commit('SET_BLOCKLOADING', { isActive: true });
  },
  unblockloading({ commit }) {
    commit('SET_BLOCKLOADING', { isActive: false });
  },
  // Reloading
  startReload({ commit }, { type }) {
    commit('SET_RELOADING_TYPE_STATUS', { type: type, reload: true });
  },
  stopReload({ commit }, { type }) {
    commit('SET_RELOADING_TYPE_STATUS', { type: type, reload: false });
  },
  setReloadData({ commit }, { type, data }) {
    commit('SET_RELOADING_TYPE_DATA', { type: type, data: data });
  },
  reload() {
    window.location.reload();
  },
  async checkReloadByBuildVersion({ dispatch }) { // env vs version.html
    const response = await axios.get(`${window.location.origin}/version.html?v=${Date.now()}`);
    await dispatch('setReloadData', { 
      type: 'buildVersion', 
      data: {
        BUILD_NUMBER: response.data,
        VUE_APP_BUILD_NUMBER: process.env.VUE_APP_BUILD_NUMBER,
      }, 
    });
    if (process.env.VUE_APP_BUILD_NUMBER != response.data) { 
      await dispatch('startReload', { type: 'buildVersion' });
      return true;
    }
    return false;
  },
  async checkReloadByRenderVersion({ dispatch }) { // env vs version.html
    const response = await axios.get(`${window.location.origin}/version_render.html?v=${Date.now()}`);
    await dispatch('setReloadData', { 
      type: 'renderVersion', 
      data: {
        RENDER_VERSION: response.data,
        VUE_APP_RENDER_VERSION: process.env.VUE_APP_RENDER_VERSION,
      }, 
    });
    if (process.env.VUE_APP_RENDER_VERSION != response.data) { 
      await dispatch('startReload', { type: 'renderVersion' });
      return true;
    }
    return false;
  },

  setScreenSize({ dispatch }, { size }) {
    dispatch("setScreenSize", { size: size }, { root: true })
  },
};

const mutations = {
  SET_IFRAME_SCALE(state, { iframeScale }) {
    state.iframeScale = iframeScale;
  },
  REGISTER_FILEMANAGER(state, { filemanager }) {
    state.filemanager = filemanager
  },
  SET_MODE(state, { mode }) {
    state.mode = mode
  },
  setStatePath(state, { value, path }) {
    setObjectPath(state, value, path)
    state = { ...state }
  },
  setIframe(state, { iframeWin }) {
    state.iframeWin = iframeWin
  },
  SET_MODAL(state, { name, payload }) {
    state.modal = name;
    state.modalPayload = payload;
  },
  // BlockLoading
  SET_BLOCKLOADING(state, { isActive }) {
    state.blockloading.isActive = isActive;
  },
  // Reloading
  SET_RELOADING_TYPE_STATUS(state, { type, reload }) {
    state.reloading.types[type].reload = reload;
  },
  SET_RELOADING_TYPE_DATA(state, { type, data }) {
    state.reloading.types[type].data = data;
  },
};

const modules = {
  site,
  userPreference,
  metadata,
  component,
  snapshot,
  page,
  frameTool,
  modals,
  original,
  permissionWebsite,
  siteData,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules
};
